import { Particle } from "@pixi/particle-emitter";
import { behaviors } from "@pixi/particle-emitter";
import { Point, Texture } from "pixi.js";
type IEmitterBehavior = behaviors.IEmitterBehavior;

export class OrderedTextureWithStartPositionBehavior implements IEmitterBehavior {
    public static type = 'textureOrderedStartPositions';

    public order = behaviors.BehaviorOrder.Normal;
    private readonly textures: Texture[];
    private readonly positions: Point[];
    private index: number;

    constructor(config: {
        textures: Texture[],
        positions: Point[]
    }) {
        if (config.textures.length != config.positions.length) {
            throw new Error("You have to provide positions for each texture.");
        }
        this.index = 0;
        this.textures = config.textures;
        this.positions = config.positions;
    }

    initParticles(first: Particle): void {
        let next = first;

        while (next) {
            next.texture = this.textures[this.index];
            const startPosition = this.positions[this.index];
            next.position.set(startPosition.x, startPosition.y);
            if (++this.index >= this.textures.length) {
                this.index = 0;
            }
            next = next.next;
        }
    }
}